import React from "react";
import Image from "next/image";
import { BASE_ASSETS_URL } from "../../../constants/constants";

const Rating = ({ rate }) => {
  return (
    <div className="flex items-center gap-4 md:gap-6 flex-wrap">
      <div className="flex items-center gap-1">
        {Array.from({ length: rate }, (_, index) => (
          <Image
            key={index}
            src={`${BASE_ASSETS_URL}/v2/landing-page/star.svg`}
            width={20}
            height={20}
            alt="star"
          />
        ))}
      </div>
      <p className="text-xl">Rated {rate}/5 - From over 2K reviews.</p>
    </div>
  );
};

export default Rating;
